<form [formGroup]="form">
  <mat-accordion>
    <mat-expansion-panel [expanded]="expandedFilter" (opened)="expandedFilter = true"
      (closed)="expandedFilter = false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'auditList.filter.title' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div fxFlex="100" fxFlex.xs="100%" fxFlex.sm="50%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'executionList.filter.test.label' | translate }}</mat-label>
          <mat-select formControlName="idTestType" [disabled]="isList === false">
            <mat-option [value]="null"> --- </mat-option>
            @for (item of typeQTypes; track item) {
              <mat-option [value]="item.id">
                {{ 'testQualification.' + item.translation | translate }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
        <button mat-raised-button (click)="doFilter()" color="primary">
          {{ 'button.filter' | translate }}
        </button>
        <button mat-button (click)="cleanFilter()">
          {{ 'button.clean' | translate }}
        </button>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</form>